import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/shared/validators/email-validator';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { LoginService } from '../login/login.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends BaseFormGroup implements OnInit {
  hide = false;
  disable = true;

  public formDetails: FormGroup;
  public isLoading: boolean;
  private client: any;
  public clientValidated: boolean;
  public clientValidationError: any;
  public showError: boolean;
  public emailSent: boolean;
  errorMessage: string;

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService, private loginService: LoginService, private commonService: CommonService) {
    super();
  }

  ngOnInit() {
    this.commonService.setLoadingFalse();
    

    const client = this.activatedRoute.snapshot.params.client;
    const queryParams = {
      clientName: client,
    };
    if (client) {
      this.isLoading = true;
      this.authService.getClientBuid(queryParams).subscribe((response) => {
        this.isLoading = false;
        this.client = response;
        this.clientValidated = true;
      }, (response) => {
          this.isLoading = false;
          this.clientValidationError = response.error.message;
      });
    }
    this.formDetails = new FormGroup({
      email: new FormControl('', [Validators.required, emailValidator])
    });
  }
  onSubmit() {
    if (this.formDetails.valid) {
      this.isLoading = true;
      const body = {
        client: this.client?.client,
        buids: this.client?.buids,
        username: this.formDetails.get('email').value,
      };
      this.loginService.resetPassword(body).subscribe((resonse) => {
        this.isLoading = false;
        this.emailSent = true;
      }, (response) => {
        this.isLoading = false;
        this.showError = true;
        this.errorMessage = response.error.message;
      });
    } else {
      this.markFormGroupDirty(this.formDetails);
    }
  }

  dismissError() {
    this.showError = false;
  }
  getEmail(val: string) {
    if (val.length > 0){
      this.disable = false;
    }
    if (val.length == 0){
      this.disable = true;
    }
  }

}
